module.exports = __webpack_public_path__ + "img/de.2acd4709.svg";